import { Routes, Route, Navigate } from "react-router-dom";
import routes from "./routes";

export default function Integration() {
  return (
    <Routes>
      <Route index element={<Navigate to="smart_links" replace />} />
      {routes.map((r) => (
        <Route path={r.route} element={r.component} key={r.key} />
      ))}
      <Route path="*" element={<Navigate to="smart_links" replace />} />
    </Routes>
  );
}
